import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  form: FormGroup;
  public showGenericLogin: boolean = true;
  constructor(private router: Router,private fb: FormBuilder, private msalService: MsalService,) {
  }
  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    }); 
  }

  public toyotaLogin(): void {
    this.msalService.loginRedirect();
  }

  public nonToyotaLogin(): void {
    this.showGenericLogin = false;
  }

  public backToGenLogin(): void {
    this.showGenericLogin = true;
  }

}
